import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Alert, Button, Snackbar } from "@mui/material";
import { NumericFormat } from "react-number-format";
import SaveIcon from "@mui/icons-material/Save";
import useScreenWidth from "../../../hooks/useScreenWidth";

const UbahKelompok = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [noKelompok, setNoKelompok] = useState("");
  const [tglKelompok, setTglKelompok] = useState("");
  const [patokanHarga, setPatokanHarga] = useState("");
  const [angsuran, setAngsuran] = useState("");
  const [totalAngsuran, setTotalAngsuran] = useState("");
  const [jangkaWaktu, setJangkaWaktu] = useState("");
  const [administrasi, setAdministrasi] = useState("");
  const [patokanBayangan, setPatokanBayangan] = useState("");
  const [keterangan, setKeterangan] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getKelompokById();
  }, []);

  const getKelompokById = async () => {
    setLoading(true);
    const pickedKelompok = await postRequest(
      `/kelompoks/${id}`,
      {},
      navigate,
      dispatch
    );
    setNoKelompok(pickedKelompok.data.noKelompok);
    setTglKelompok(pickedKelompok.data.tglKelompok);
    setPatokanHarga(pickedKelompok.data.patokanHarga);
    setAngsuran(pickedKelompok.data.angsuran);
    setTotalAngsuran(pickedKelompok.data.totalAngsuran);
    setJangkaWaktu(pickedKelompok.data.jangkaWaktu);
    setAdministrasi(pickedKelompok.data.administrasi);
    setPatokanBayangan(pickedKelompok.data.patokanBayangan);
    setKeterangan(pickedKelompok.data.keterangan);
    setLoading(false);
  };

  const updateKelompok = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      try {
        setLoading(true);
        postRequest(
          `/updateKelompok/${id}`,
          {
            patokanHarga,
            angsuran,
            totalAngsuran,
            jangkaWaktu,
            administrasi,
            patokanBayangan,
            keterangan,
          },
          navigate,
          dispatch
        );
        setLoading(false);
        navigate(`/daftarKelompok/kelompok/${id}`);
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Arisan</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Kelompok</h5>
      <hr />
      <Card>
        <Card.Header>Kelompok</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={updateKelompok}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    No. Kelompok :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control
                      required
                      value={noKelompok}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Tanggal :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control
                      required
                      value={tglKelompok}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Patokan Harga <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={patokanHarga}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        setPatokanHarga(
                          values.formattedValue
                            .split(".")
                            .join("")
                            .replace(/,/g, "")
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Angsuran <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={angsuran}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        let tempNumber = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");

                        setAngsuran(tempNumber);

                        let tempTotalAngsuran =
                          parseInt(tempNumber) * parseInt(jangkaWaktu);
                        setTotalAngsuran(tempTotalAngsuran);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Jangka Waktu <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={jangkaWaktu}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        let tempNumber = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");

                        setJangkaWaktu(tempNumber);

                        let tempTotalAngsuran =
                          parseInt(angsuran) * parseInt(tempNumber);
                        setTotalAngsuran(tempTotalAngsuran);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Total Angsuran <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={totalAngsuran}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        setTotalAngsuran(
                          values.formattedValue
                            .split(".")
                            .join("")
                            .replace(/,/g, "")
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Administrasi (%) <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control
                      required
                      type="number"
                      value={administrasi}
                      onChange={(e) => setAdministrasi(e.target.value)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Patokan Bayangan (%) <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control
                      required
                      type="number"
                      value={patokanBayangan}
                      onChange={(e) => setPatokanBayangan(e.target.value)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={keterangan}
                      onChange={(e) => {
                        setKeterangan(e.target.value);
                      }}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate(`/daftarKelompok/kelompok/${id}`)}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahKelompok;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "800px",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};
